import { jsx as o, jsxs as p, Fragment as C } from "react/jsx-runtime";
import "@material-ui/core/Box";
import $ from "@material-ui/core/Button";
import q from "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import z from "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import F from "@material-ui/core/ExpansionPanel";
import G from "@material-ui/core/ExpansionPanelDetails";
import H from "@material-ui/core/ExpansionPanelSummary";
import J from "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import l from "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import u from "@material-ui/core/Select";
import K from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import Q from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import U from "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import V from "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import X from "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { useEnumeration as Y, PageLoading as Z, SelectInput as b } from "@propify-tenant-client/common";
import { formatCurrency as N } from "@propify/components";
import E from "classnames";
import { useMemo as _ } from "react";
const R = (e) => K({
  root: {
    display: "flex",
    padding: "0.5em",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    maxWidth: "100vw",
    [e.breakpoints.down("sm")]: {
      justifyContent: "center"
    }
  },
  only: {
    justifyContent: "center"
  },
  toolbar: {
    width: "100%",
    display: "flex",
    padding: "0.5em 1em",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center"
  },
  toolbarAutoWidth: {
    width: "auto",
    marginLeft: "auto",
    marginRight: "auto"
  },
  shadow: {
    boxShadow: "0px 7px 8px -4px rgba(0,0,0,0.3),0px 12px 17px 2px rgba(0,0,0,0.2),0px 5px 22px 4px rgba(0,0,0,0.18)"
  },
  search: {
    display: "flex",
    marginRight: "0.5em",
    [e.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: "0.5em",
      marginRight: 0
    }
  },
  searchButton: {
    marginLeft: "0.5em"
  },
  range: {
    [e.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  control: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "0.5em",
    [e.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "0.5em"
    }
  }
}), tt = ({
  classes: e,
  filter: m = {},
  setFilter: s,
  onSearch: M,
  states: v,
  width: k,
  onlySearchBar: h = !1
}) => {
  var y;
  const { data: g, isFetching: P } = Y("state"), I = _(
    () => v.map((t) => g.find((a) => a.value === t)).sort((t, a) => t.displayName > a.displayName ? 1 : -1),
    [g, v]
  ), x = (t) => (a) => {
    const { value: r } = a.target, { displayRent: i } = m;
    s({
      ...m,
      displayRent: { ...i, [t]: r === "0" ? "" : r }
    });
  }, S = (t) => {
    s({
      ...m,
      availableNow: t.target.checked
    });
  }, W = (t) => (a) => {
    const { value: r } = a.target, { bedroomCount: i } = m;
    s({
      ...m,
      bedroomCount: { ...i, [t]: r === "0" ? "" : r }
    });
  }, B = (t) => (a) => {
    const { value: r } = a.target, { bathroomCount: i } = m;
    s({
      ...m,
      bathroomCount: { ...i, [t]: r === "0" ? "" : r }
    });
  }, j = () => [
    {
      value: "0",
      label: "0+"
    },
    {
      value: "1",
      label: "1+"
    },
    {
      value: "2",
      label: "2+"
    },
    {
      value: "3",
      label: "3+"
    },
    {
      value: "4",
      label: "4+"
    },
    {
      value: "5",
      label: "5+"
    }
  ], A = () => [
    {
      value: "0",
      label: "0+"
    },
    {
      value: "1",
      label: "1.0+"
    },
    {
      value: "1.5",
      label: "1.5+"
    },
    {
      value: "2",
      label: "2.0+"
    },
    {
      value: "2.5",
      label: "2.5+"
    },
    {
      value: "3",
      label: "3.0+"
    },
    {
      value: "4",
      label: "4.0+"
    }
  ], D = () => [0, 1e3, 1250, 1500, 1750, 2e3].map((t) => ({
    value: `${t}`,
    label: N(t, { noEmptyDecimals: !0 })
  })), L = () => [1e3, 1250, 1500, 1750, 2e3, 2250, 2500, 2750, 3e3].map((t) => ({
    value: `${t}`,
    label: N(t, { noEmptyDecimals: !0 })
  })), f = () => /* @__PURE__ */ o(
    $,
    {
      variant: "contained",
      color: "primary",
      className: e.searchButton,
      endIcon: /* @__PURE__ */ o(X, {}),
      type: "button",
      onClick: M,
      children: "Search"
    }
  ), d = () => ["xs", "sm"].includes(k), O = (t) => {
    var r;
    const { value: a } = t.target;
    s({
      ...m,
      state: ((r = g.find((i) => i.value === a)) == null ? void 0 : r.value) ?? ""
    });
  }, w = () => {
    const { displayRent: t, availableNow: a, bedroomCount: r, bathroomCount: i } = m;
    return /* @__PURE__ */ p(C, { children: [
      /* @__PURE__ */ o("div", { className: e.control, children: /* @__PURE__ */ p(
        u,
        {
          style: { width: d() ? "100%" : 125 },
          value: (t == null ? void 0 : t.min) ?? "",
          onChange: x("min"),
          input: /* @__PURE__ */ o(b, {}),
          displayEmpty: !0,
          children: [
            /* @__PURE__ */ o(l, { value: "", disabled: !0, children: "Min Rent" }),
            D().map(({ value: n, label: c }) => /* @__PURE__ */ p(
              l,
              {
                value: n,
                disabled: t != null && t.max ? n >= (t == null ? void 0 : t.max) : !1,
                children: [
                  c,
                  "+"
                ]
              },
              n
            ))
          ]
        }
      ) }),
      /* @__PURE__ */ o("div", { className: e.control, children: /* @__PURE__ */ p(
        u,
        {
          style: { width: d() ? "100%" : 125 },
          value: (t == null ? void 0 : t.max) ?? "",
          onChange: x("max"),
          input: /* @__PURE__ */ o(b, {}),
          displayEmpty: !0,
          children: [
            /* @__PURE__ */ o(l, { value: "", disabled: !0, children: "Max Rent" }),
            L().map(({ value: n, label: c }) => /* @__PURE__ */ o(
              l,
              {
                value: n,
                disabled: t != null && t.min ? n <= (t == null ? void 0 : t.min) : !1,
                children: c
              },
              n
            )),
            /* @__PURE__ */ o(l, { value: "0", children: "Any Price" })
          ]
        }
      ) }),
      /* @__PURE__ */ o("div", { className: e.control, children: /* @__PURE__ */ p(
        u,
        {
          style: { width: d() ? "100%" : 125 },
          value: (r == null ? void 0 : r.min) ?? "",
          onChange: W("min"),
          input: /* @__PURE__ */ o(b, {}),
          displayEmpty: !0,
          children: [
            /* @__PURE__ */ o(l, { value: "", disabled: !0, children: "Min Beds" }),
            j().map(({ value: n, label: c }) => /* @__PURE__ */ o(l, { value: n, children: c }, n))
          ]
        }
      ) }),
      /* @__PURE__ */ o("div", { className: e.control, children: /* @__PURE__ */ p(
        u,
        {
          style: { width: d() ? "100%" : 125 },
          value: (i == null ? void 0 : i.min) ?? "",
          onChange: B("min"),
          input: /* @__PURE__ */ o(b, {}),
          displayEmpty: !0,
          children: [
            /* @__PURE__ */ o(l, { value: "", disabled: !0, children: "Min Baths" }),
            A().map(({ value: n, label: c }) => /* @__PURE__ */ o(l, { value: n, children: c }, n))
          ]
        }
      ) }),
      /* @__PURE__ */ o("div", { className: e.control, children: /* @__PURE__ */ o(
        J,
        {
          control: /* @__PURE__ */ o(
            z,
            {
              color: "primary",
              checked: a ?? !1,
              onChange: S
            }
          ),
          label: "Available Now",
          labelPlacement: "end"
        }
      ) }),
      h && !d() && /* @__PURE__ */ o("div", { className: e.control, children: f() })
    ] });
  };
  if (P)
    return /* @__PURE__ */ o(Z, {});
  const T = /* @__PURE__ */ p(C, { children: [
    /* @__PURE__ */ p("div", { className: e.search, children: [
      /* @__PURE__ */ p(
        u,
        {
          style: { width: d() ? "100%" : 200 },
          value: ((y = g.find((t) => t.value === m.state)) == null ? void 0 : y.value) ?? "",
          onChange: O,
          input: /* @__PURE__ */ o(b, {}),
          displayEmpty: !0,
          children: [
            /* @__PURE__ */ o(l, { value: "", children: "All States" }),
            I.map(({ value: t, displayName: a }) => /* @__PURE__ */ o(l, { value: t, children: a }, t))
          ]
        }
      ),
      d() && h && f()
    ] }),
    d() ? /* @__PURE__ */ p(F, { style: { width: "100%" }, children: [
      /* @__PURE__ */ o(H, { expandIcon: /* @__PURE__ */ o(V, {}), children: "Filters" }),
      /* @__PURE__ */ o(G, { className: e.toolbar, children: w() })
    ] }) : w()
  ] });
  return /* @__PURE__ */ o(
    "div",
    {
      className: E(e.root, {
        [e.only]: h
      }),
      children: /* @__PURE__ */ o(
        q,
        {
          className: E({
            [e.toolbar]: !0,
            [e.toolbarAutoWidth]: h,
            [e.shadow]: h
          }),
          children: T
        }
      )
    }
  );
}, to = U()(Q(R, { name: "Toolbar" })(tt));
export {
  to as default
};
//# sourceMappingURL=Toolbar.js.map
